import React, { Fragment, useEffect } from 'react';
import { observer } from 'mobx-react';
import ErrorMessage from '../../components/errormessage';
import ThemedSpinner from '../../components/themed/ThemedSpinner';
import { useStores } from '../../hooks/use-stores';
import { useParams } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import AddRemoveList from '../../components/super/add-remove-list';

function SubjectCategories() {
    const { superStore } = useStores();
    let { subjectId } = useParams();
    const {
        loadingSubject,
        editingSubject,
        categoriesErrorError,
        loadingCategories,
        categories,
        //loadCategorySubjects,
        editingSubjectCategories,
        addCategorySubject,
        deleteCategorySubject,
    } = superStore;

    const loadData = async () => {
        await superStore.loadCategories();
        await superStore.loadSubject(subjectId);
        await superStore.loadSubjectCategories(subjectId);
    };

    useEffect(() => {
        loadData();
    }, [subjectId]);

    /*const mapSubjects = async (subjects) => {
        return await subjects.map((item) => {
            item.name = `[${item.episode_number}] ${item.title}`;
        });
    };*/

    console.log(loadingSubject, loadingCategories, editingSubjectCategories);

    return (
        <Grid
            container
            direction="row"
            justify="center"
            align="center"
            spacing={2}
        >
            {loadingSubject || loadingCategories ? (
                <>
                    <ThemedSpinner />
                </>
            ) : (
                <Fragment>
                    {categoriesErrorError && (
                        <Grid item>
                            <ErrorMessage error={categoriesErrorError} />
                        </Grid>
                    )}
                    {editingSubject && (
                        <Fragment>
                            <Grid item xs={12}>
                                <Box mt={4}>
                                    <Typography variant="h2">
                                        Subject{`: ${editingSubject.title}`}
                                    </Typography>
                                </Box>
                            </Grid>
                            <Fragment>
                                <Grid item xs={12}>
                                    <Typography variant="h4" gutterBottom>
                                        Categories
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <AddRemoveList
                                        addItem={async (categoryId) => {
                                            await addCategorySubject(
                                                categoryId,
                                                subjectId
                                            );
                                            await superStore.loadSubjectCategories(
                                                subjectId
                                            );
                                        }}
                                        removeItem={async (categoryId) => {
                                            await deleteCategorySubject(
                                                categoryId,
                                                subjectId
                                            );
                                            await superStore.loadSubjectCategories(
                                                subjectId
                                            );
                                        }}
                                        itemList={categories}
                                        activeItemList={
                                            editingSubjectCategories
                                        }
                                        idColumn={'id'}
                                        nameColumn={'name'}
                                    />
                                </Grid>
                            </Fragment>
                        </Fragment>
                    )}
                </Fragment>
            )}
        </Grid>
    );
}

export default observer(SubjectCategories);
